import { GetBkgHeader } from '../Functions/GetBkgHeader.js';
import { MickeyMouseSVG } from '../Document/MickeyMouseSVG.js'

export const Header = () => {
    const uri = window.location.href;
    const bkg = GetBkgHeader(uri);
    return (
        <header id="header" className={`header img-${bkg}`}>
            <a className="logo-title" href="/" alt="Home">
            <MickeyMouseSVG />
                <div className="item1">Rencontre</div>
                <div className="item2">ta Souris</div>
                <div className="item3">à Disneyland Paris</div>
            </a>
            <div className="logo-text">
                Liste des attractions et personnages de Disneyland Paris
                classés par parcs, univers, catégories et origines.
            </div>
        </header>
    )
}
